(function () {
  var root = document.querySelector('.adv-root');
  if (!root) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Largeur de viewport sans la barre de defilement. */
  function setVw() {
    root.style.setProperty('--adv-vw', document.documentElement.clientWidth + 'px');
  }
  setVw();
  window.addEventListener('resize', setVw, { passive: true });
  window.addEventListener('orientationchange', setVw, { passive: true });

  /* Fondu ascendant a l'entree dans le viewport. */
  if (!reduce && 'IntersectionObserver' in window) {
    var sel = '.adv-article .adv-img, .adv-article > blockquote, .adv-note, .adv-diagram,'
            + ' .adv-review, .adv-voice, .adv-ratings, .adv-cta-box, .adv-qa__item';
    var targets = root.querySelectorAll(sel);
    if (targets.length) {
      root.classList.add('adv-motion');
      for (var i = 0; i < targets.length; i++) targets[i].classList.add('adv-reveal');
      var io = new IntersectionObserver(function (entries) {
        for (var j = 0; j < entries.length; j++) {
          if (entries[j].isIntersecting) {
            entries[j].target.classList.add('is-in');
            io.unobserve(entries[j].target);
          }
        }
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      for (var k = 0; k < targets.length; k++) io.observe(targets[k]);
      /* filet de securite : rien ne doit rester invisible */
      setTimeout(function () {
        var hidden = root.querySelectorAll('.adv-reveal:not(.is-in)');
        for (var n = 0; n < hidden.length; n++) {
          if (hidden[n].getBoundingClientRect().top < window.innerHeight) {
            hidden[n].classList.add('is-in');
          }
        }
      }, 3000);
    }
  }

  /* ------------------------------------------------------------------
     Barre de progression.
     Elle se mesure sur l'article lui-meme et non sur la hauteur totale
     du document : le pied de page, le CTA collant et les marges basses
     faussaient le calcul, la barre n'atteignait pas 100 % en fin de
     lecture. Elle est relue au chargement de chaque image, dont
     l'arrivee modifie la hauteur de l'article.
     ------------------------------------------------------------------ */
  var article = root.querySelector('.adv-article');
  var bar = document.createElement('div');
  bar.className = 'adv-progress';
  var fill = document.createElement('span');
  fill.className = 'adv-progress__f';
  bar.appendChild(fill);
  root.insertBefore(bar, root.firstChild);

  var ticking = false;

  function update() {
    ticking = false;
    if (!article) { fill.style.width = '0%'; return; }
    var haut = article.getBoundingClientRect().top + window.scrollY;
    var hauteur = article.offsetHeight;
    if (hauteur <= 0) { fill.style.width = '0%'; return; }
    /* 0 % quand le haut de l'article touche le bas de l'ecran,
       100 % quand son bas le touche a son tour. */
    var pct = ((window.scrollY + window.innerHeight) - haut) / hauteur * 100;
    if (pct < 0) pct = 0;
    if (pct > 100) pct = 100;
    fill.style.width = pct.toFixed(2) + '%';
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('load', update);
  if (article) {
    var imgs = article.querySelectorAll('img');
    for (var m = 0; m < imgs.length; m++) imgs[m].addEventListener('load', onScroll);
  }
  update();
})();
